export enum DiscountProgramAggregatePathEnum {
  aggregate = 'aggregate/v1/catalog/courses/discount-programs/',
  aggregateAuth = 'aggregate/v1/auth/catalog/courses/discount-programs/',
}
